var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepRedAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.75,
    r: 12,
    fill: "white",
    stroke: "#F4F6F9",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.75C14.2833 19.75 14.5208 19.6542 14.7125 19.4625C14.9042 19.2708 15 19.0333 15 18.75C15 18.4667 14.9042 18.2292 14.7125 18.0375C14.5208 17.8458 14.2833 17.75 14 17.75C13.7167 17.75 13.4792 17.8458 13.2875 18.0375C13.0958 18.2292 13 18.4667 13 18.75C13 19.0333 13.0958 19.2708 13.2875 19.4625C13.4792 19.6542 13.7167 19.75 14 19.75ZM13 15.75H15V9.75H13V15.75ZM14 24.75C12.6167 24.75 11.3167 24.4875 10.1 23.9625C8.88333 23.4375 7.825 22.725 6.925 21.825C6.025 20.925 5.3125 19.8667 4.7875 18.65C4.2625 17.4333 4 16.1333 4 14.75C4 13.3667 4.2625 12.0667 4.7875 10.85C5.3125 9.63333 6.025 8.575 6.925 7.675C7.825 6.775 8.88333 6.0625 10.1 5.5375C11.3167 5.0125 12.6167 4.75 14 4.75C15.3833 4.75 16.6833 5.0125 17.9 5.5375C19.1167 6.0625 20.175 6.775 21.075 7.675C21.975 8.575 22.6875 9.63333 23.2125 10.85C23.7375 12.0667 24 13.3667 24 14.75C24 16.1333 23.7375 17.4333 23.2125 18.65C22.6875 19.8667 21.975 20.925 21.075 21.825C20.175 22.725 19.1167 23.4375 17.9 23.9625C16.6833 24.4875 15.3833 24.75 14 24.75Z",
    fill: "#EA001E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepRedAlert);
export default __webpack_public_path__ + "static/media/step_red_alert.184e8308274b98b19095affd7f4d6447.svg";
export { ForwardRef as ReactComponent };